export const AwscInitiationMethod = Object.freeze({
  Outbound: 'OUTBOUND',
  Inbound: 'INBOUND',
});
